import CheckList from "../pengecekan-form/CheckList";

/**
 * The checklists of the audit: bagian depan, samping, belakang, dalam and (when there is a trailer) the trailer.
 */
const EditorChecklistSection = ({
  listProblemData,
  headerData,
  permittedToEdit,
  loading,
  folderName,
  pengecekanDetilData,
  setPengecekanDetilData,
  handleOnClickReload,
  handleOnClickDeskripsi,
  handleOnClickSaveCheckList,
}) => {
  const disabled = headerData.id && permittedToEdit ? false : true;

  // checklist card of one bagian of the vehicle (or of the trailer)
  const renderBagian = ({ title, labelGrup, wrapperClassName }) => (
    <div
      className={
        wrapperClassName ?? "elevated-card grow row-start-start !py-4 !px-4"
      }
    >
      <CheckList
        listProblemData={listProblemData.filter(
          (el) => el.label_grup === labelGrup
        )}
        folderName={folderName}
        onClickDeskripsi={handleOnClickDeskripsi}
        disabled={disabled}
        title={title}
        labelGrup={labelGrup}
        pengecekanDetilData={pengecekanDetilData}
        setPengecekanDetilData={setPengecekanDetilData}
        onClickReload={handleOnClickReload}
        onClickSave={(detils) =>
          handleOnClickSaveCheckList({
            detils,
          })
        }
        loading={loading}
      />
    </div>
  );

  return (
    <>
      <div className="row-start-start w-full flex-wrap gap-4">
        {/* check list depan */}
        {renderBagian({ title: "Bagian Depan", labelGrup: "bagian_depan" })}
        {/* check list samping */}
        {renderBagian({ title: "Bagian Samping", labelGrup: "bagian_samping" })}
      </div>
      <div className="row-start-start w-full flex-wrap gap-4">
        {/* check list belakang */}
        {renderBagian({
          title: "Bagian Belakang",
          labelGrup: "bagian_belakang",
        })}
        {/* check list dalam */}
        {renderBagian({ title: "Bagian Dalam", labelGrup: "bagian_dalam" })}
      </div>
      {(headerData.trailer_id || headerData.data_trailer) && (
        <div className="row-start-start w-full flex-wrap gap-4">
          {/* check trailer */}
          {renderBagian({
            title: "Trailer",
            labelGrup: "trailer",
            wrapperClassName:
              "elevated-card grow row-start-start !py-4 !px-4 md:grow-0 md:w-[50%]",
          })}
        </div>
      )}
    </>
  );
};

export default EditorChecklistSection;
